package com.sweetlime.bingeamigo.model

import kotlinx.serialization.Serializable

@Serializable
data class ContentSummary(
    val ratingSum: Double = 0.0,
    val reviewCount: Int = 0,
    val avgRating: Double = 0.0
)